module.exports = __webpack_public_path__ + "img/logo6_med.original_v02.376fdbdf.png";